import { useMemo } from "react";
import { ButtonWrap } from "@hopper-b2b/ui";
import { Typography } from "@material-ui/core";
import Chevron from "../../../../../../assets/client/chevron.svg";
import ChevronWhite from "../../../../../../assets/client/darkMode/chevron-white.svg";
import DollarSignWhite from "../../../../../../assets/client/darkMode/dollar-sign-white.svg";
import DollarSign from "../../../../../../assets/client/dollar-sign.svg";
import "./styles.scss";
import { useDarkModePreferred } from "../../../../../../utils/colors";

export interface PriceSummaryRowProps {
  priceString: string;
  description?: string;
  onClick?: () => void;
}

export const PriceSummaryRow = ({
  priceString,
  description,
  onClick,
}: PriceSummaryRowProps) => {
  const isDarkModePreferred = useDarkModePreferred();
  const summaryRow = useMemo(() => {
    return (
      <div className="price-summary-row">
        <div className="price-summary-row-left">
          <div className="price-summary-row-icon">
            <img
              className="mobile-left-icon"
              src={isDarkModePreferred ? DollarSignWhite : DollarSign}
              alt=""
            />
          </div>

          <div className="price-summary-row-value">
            <div className="price-text">
              <Typography className="content" variant="body1">
                {priceString}
              </Typography>
            </div>
            {description ? (
              <div className="description-text">{description}</div>
            ) : null}
          </div>
        </div>
        <div className="price-summary-row-right">
          {onClick ? (
            <img
              className="mobile-right-chevron"
              src={isDarkModePreferred ? ChevronWhite : Chevron}
              alt=""
            />
          ) : null}
        </div>
      </div>
    );
  }, [description, isDarkModePreferred, onClick, priceString]);

  return onClick ? (
    <ButtonWrap className="price-summary-row-button" onClick={onClick}>
      {summaryRow}
    </ButtonWrap>
  ) : (
    summaryRow
  );
};

export default PriceSummaryRow;
